<div class="global-loading-mask" *ngIf="loading$ | async">
  <div class="global-loading-spinner">
    <div class="spinner"></div>
  </div>
</div>
